import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Col, Row, notification } from "antd";
import { banUser } from "../../helpers/report";
import CustomSheet from "../CustomSheet";
import userModel from "../../lib/firebase/userModel";

export default function BanUserSheet({ isOpen, setOpen, user }) {
  const [api, contextHolder] = notification.useNotification();
  const [isSending, setIsSending] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const openNotification = () => {
    const key = `open${Date.now()}`;
    api.open({
      description: (
        <Row>
          <Col span={22}>
            <Message>You have banned @{userInfo && userInfo.username}</Message>
          </Col>
          <Col span={2}></Col>
        </Row>
      ),
      key,
      duration: 10,
      className: "admin-notification",
      closeIcon: <CloseIcon src="/icons/x-icon-gray.svg" alt="" />,
    });
  };

  useEffect(() => {
    async function fetchData() {
      const userInfo = await userModel.getOneById(user);
      setUserInfo(userInfo);
    }
    if (user) fetchData();
  }, [user]);

  const startBanningUser = async () => {
    setIsSending(true);
    const result = await banUser(user);
    if (result) {
      openNotification();
      setOpen(false);
    }
    setIsSending(false);
  };

  useEffect(() => {
    if (isOpen) setIsSending(false);
  }, [isOpen]);

  return (
    <>
      {contextHolder}
      <CustomSheet
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        snapPoints={[325]}
        tweenConfig={{ ease: "easeOut", duration: 0.3 }}
      >
        <InnerContainer>
          <ProfileImage src={userInfo && userInfo.pfp} alt="" />
          <Header>Ban {userInfo && userInfo.username}?</Header>
          <Content>
            Banning indefinitely removes username and profile picture from all of{" "}
            {userInfo && userInfo.username}'s content.
          </Content>
          {!isSending ? (
            <SendReportButton onClick={async () => await startBanningUser()}>Ban</SendReportButton>
          ) : (
            <SendReportButton disabled>
              <Spinner alt="" src="/icons/loading-spheres.svg" />
            </SendReportButton>
          )}
        </InnerContainer>
      </CustomSheet>
    </>
  );
}

const Header = styled.div`
  color: var(--color-cream-base);
  text-align: center;
  font-family: var(--font-primary);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 14px;
`;

const Content = styled.div`
  color: var(--color-gray-50);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 22.4px */
  margin-top: 12px;
`;

const InnerContainer = styled.div`
  width: 85%;
  margin: 0px auto;
  text-align: center;
`;

const CloseIcon = styled.img`
  height: 10px;
  width: 10px;
  position: absolute;
  opacity: 0.5;
  top: 10px;
`;

const Spinner = styled.img`
  width: 25px;
  height: 25px;
  animation: rotation 2s infinite linear;
`;

const SendReportButton = styled.button`
  width: 100%;
  height: 50px;
  background: var(--blurple);
  border: 0;
  border-radius: 90px;
  margin-top: 20px;
  cursor: pointer;
  line-height: 16px;
  letter-spacing: 0em;
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  text-align: center;
  align-items: center;
  align-self: stretch;
  color: var(--color-cream-base);
  font-family: var(--font-primary);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
`;

const Message = styled.span`
  color: var(--color-red);
`;

const ProfileImage = styled.img`
  height: 82px;
  width: 82px;
  text-align: center;
  margin-top: 14px;
  border-radius: 82px;
  border: 2px solid #252525;
`;
